import {Injectable} from '@angular/core';
import {ActivatedRoute, EventType, NavigationEnd, Router} from '@angular/router';
import {filter, map} from 'rxjs/operators';
import {LocaleService} from "./locale.service";

@Injectable()
export class LanguageInterceptor {
  constructor(
    private router: Router,
    private localeService: LocaleService,
    private activatedRoute: ActivatedRoute
  ) {
  }

  public initialize(): void {
    this.router.events
      .pipe(
        filter(event => event.type === EventType.NavigationEnd),
        map((event) => {
          return event as NavigationEnd;
        })
      ).subscribe({
      next: (event: NavigationEnd) => {

        let url = event.urlAfterRedirects || event.url;
        url = url.toLowerCase();

        const localeFromPath = this.localeService.getLocaleFromPath(url);

        if (localeFromPath === undefined) {
          return this.redirectToDefaultLanguage(url);
        }

        this.localeService.setLocale(localeFromPath);

      }
    });
  }


  private redirectToDefaultLanguage(url: string): void {

    const languagePrefix = this.localeService.getDefaultLocale();
    let redirectUrl = `${languagePrefix}${url}`;

    if (url === '/') {
      // Root page ("/") redirection
      redirectUrl = languagePrefix;
    }

    // Redirect to the same route with the language prefix
    this.router.navigate(
      [redirectUrl],
      {
        skipLocationChange: false,
        replaceUrl: true,
        queryParamsHandling: 'merge',
        onSameUrlNavigation: 'reload',
        queryParams: this.activatedRoute.snapshot.queryParams
      }
    );
  }
}
